import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { cn } from '@/lib/utils';
// import "@/assets/js/drawer";

const SidebarDrawer = ({ drawerClassName, drawerBodyClassName, buttonClassName, buttonIcon, buttonIconClassName, activeDrawer, handleDrawerClose, titleText = '', children }) => {
    return (
        <div className="">
            <div className={cn('drawer', drawerClassName, activeDrawer === true ? 'active' : '')}>
                <div className="drawer-dialog">
                    <div className="drawer-header">
                        <h3 className="drawer-title"> {titleText && <>{titleText}</>}</h3>
                        <button className="fa-solid fa-xmark close-btn close-drawer" onClick={handleDrawerClose}></button>
                    </div>
                    <div className={cn('drawer-body', drawerBodyClassName)}>{children}</div>
                </div>
            </div>
            <div className={cn('backdrop', activeDrawer === true ? 'active' : '')} onClick={handleDrawerClose}></div>
        </div>
    );
};

export default SidebarDrawer;
